import styled from '@emotion/styled'
import { Colors } from 'src/components/theme'
import AlphaMapIcon from 'src/assets/images/icon-dark-mode.svg'

const AlphaMapMobilityBadgeWrapper = styled.div`
  width: 16.5px;
  height: 16.5px;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${Colors.textMedium};
  border-radius: 3px;
  padding: 2px;
  img {
    height: 100%;
    object-fit: cover;
  }
  opacity: 0;
`

export const AlphaMapMobilityBadge = () => {
  return (
    <AlphaMapMobilityBadgeWrapper>
      <img src={AlphaMapIcon} />
    </AlphaMapMobilityBadgeWrapper>
  )
}
